import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsIntervalUnit, PmsIntervalUnit } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsIntervalUnit>
    useData={usePmsIntervalUnit}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
